import IntelLayout from "../../components/layout/layout";
import styles from "./AddressBook.module.scss";
import { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { getApiUrl } from "@utils/baseUrl";
import Pagination from "react-js-pagination";
import { ChevronLeft, ChevronRight } from "react-feather";
import DateRangePickerSelfComponent from "@components/date-range-picker/date-range-picker";
import moment from "moment";
import { tempReturnObject as DateRangeOptions, intelAPIEndpoints } from "@routes/intel/dashboard/const";
import { generateTrackingObject, getInitials, getRedirectProfileType } from "@core/global/global-country-functions";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { formatStringCase, getTitleCase } from "@utils/utils";
import ReactTooltip from "react-tooltip";
import LoadingSkeleton from "@shared/LoadingSkeleton";
import RedirectProfile from "@shared/country-components/redirect-profile";
import SalesforceDuplicateModal from "@shared/salesforce-duplicate-modal";
import TabelRedirectionColumn from "@components/templates/Profile/ProfileTable/TabelRedirectionColumn";
import { CircularProgressbar } from "react-circular-progressbar";
import commaFormat from "@utils/commaFormat";
import { CLOUDINARY_INTEL_BASE_URL } from "@utils/enum";
import { trademoTrackingEvents } from "@core/global/trademo-tracking";
import trackingEventDictionary from "@core/dictionary/tracking-event";
import { useLocation } from "react-router-dom";
import { TabComponent } from "./components/Tab";
import AIFetchedContacts from "./components/AiFetchedContacts";
import { mainContactTabs } from "@containers/CompanyBookmark/utils/constant";
import LinkedIn from "@assets/images/linkedin.svg";
import { getSidebarCountData } from "@redux/Sidebar/sidebarCount.action";
import { captureException } from "@sentry/react";
const dynamicAvatarColors = ["#EAECF5", "#E0F2FE", "#E0EAFF", "#EBE9FE", "#FCE7F6", "#FEF0C7"];
let timer;
const DashboardAddressBook = () => {
  const location = useLocation();
  const { is_salesforce_active, is_zoho_active, is_hubspot_active } = useSelector((state) => state?.userDetails?.userData);
  const [contactsData, setContactsData] = useState([]);
  const [dataPerPage, setDataPerPage] = useState(6);
  const [selectedContacts, setSelectedContacts] = useState({});
  const [contactsCount, setContactsCount] = useState(0);
  const [totalCompanyCount, setTotalCompanyCount] = useState(0);
  const [searchedContact, setSearchedContact] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [dateRange, setDateRange] = useState({ from: "", to: "" });
  const [selectedDateRange, setSelectedDateRange] = useState({ from: "", to: "" });
  const [aiDateRange, setAIDateRange] = useState({ from: "", to: "" });
  const [selectedAIDateRange, setSelectedAIDateRange] = useState({ from: "", to: "" });
  const [isLoading, setIsLoading] = useState(true);
  const [showSalesForceDuplicateModal, setShowSalesForceDuplicateModal] = useState(false);
  const [duplicateSalesforceData, setDuplicateSalesforceData] = useState({});
  const [contactCredits, setContactCredtis] = useState({ totalCredit: 0, usedCredit: 0 });
  const [aiContactData, setAIContactData] = useState([]);
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [selectedPhones, setSelectedPhones] = useState([]);
  const [aiContactsMustData, setAIContactsMustData] = useState([]);
  const [showNotification, setShowNotification] = useState(false);
  const [type, setType] = useState(mainContactTabs.company);
  const dispatch = useDispatch();

  const avatarBgColors = useMemo(() => {
    let colorArr = [];
    for (let i = 0; i < dataPerPage; i++) {
      colorArr.push(dynamicAvatarColors[Math.floor(Math.random() * dynamicAvatarColors.length)]);
    }
    return colorArr;
  }, [currentPage, dataPerPage]);

  const handleCheckboxChange = (e, item, companyId) => {
    if (e.target.name === "email") {
      setSelectedEmails((prev) => (prev.includes(item.contact_value + companyId) ? prev.filter((email) => email !== item.contact_value + companyId) : [...prev, item.contact_value + companyId]));
    } else if (e.target.name === "phone") {
      setSelectedPhones((prev) => (prev.includes(item.contact_value + companyId) ? prev.filter((p) => p !== item.contact_value + companyId) : [...prev, item.contact_value + companyId]));
    }
    let id = companyId;
    let tempSelectedObj = JSON.parse(JSON.stringify(selectedContacts));
    if (e.target.checked) {
      if (id && !selectedContacts[id]) {
        tempSelectedObj[id] = JSON.parse(JSON.stringify(aiContactData.find((item) => item.company_id === id)));
        setSelectedContacts(JSON.parse(JSON.stringify(tempSelectedObj)));
      }
    } else {
      if (id && selectedContacts[id]) {
        delete tempSelectedObj[id];
        setSelectedContacts(JSON.parse(JSON.stringify(tempSelectedObj)));
      }
    }
  };
  const getDashboardContacts = (text, from, tempDateRange) => {
    let payload = {
      section_type: "address_book",
      from: from || 0,
      search: text,
    };
    if (tempDateRange?.from && tempDateRange?.to) {
      payload.from_date = tempDateRange.from;
      payload.to_date = tempDateRange.to;
    }
    setIsLoading(true);
    axios
      .post(getApiUrl("userDashboard"), payload)
      .then((response) => {
        if (response?.data?.addressBookResponse?.data) {
          if (payload.from !== 0) {
            setContactsData(JSON.parse(JSON.stringify([...contactsData, ...response.data.addressBookResponse.data])));
          } else {
            setContactsData(JSON.parse(JSON.stringify(response.data.addressBookResponse.data)));
            setContactsCount(response.data.addressBookResponse.count);
            if (!payload.from_date || !payload.to_date) {
              setContactCredtis({ totalCredit: response.data.addressBookResponse?.contact_max_request || 0, usedCredit: response.data.addressBookResponse?.contact_current_request || 0 });
              setDateRange(JSON.parse(JSON.stringify({ from: response.data.addressBookResponse.from_date, to: response.data.addressBookResponse.to_date })));
              setSelectedDateRange(JSON.parse(JSON.stringify({ from: response.data.addressBookResponse.from_date, to: response.data.addressBookResponse.to_date })));
            }
          }
        }
      })
      .finally(() => setIsLoading(false));
  };
  const handleSelection = (item, isChecked) => {
    let tempSelectedObj = JSON.parse(JSON.stringify(selectedContacts));
    if (type === mainContactTabs.ai) {
      let id = item?.company_id;
      if (isChecked && id) {
        if (!selectedContacts[id]) {
          tempSelectedObj[id] = JSON.parse(JSON.stringify(item));
        }
        setSelectedEmails((prev) => {
          const newEmails = item.email_data.map((email) => email.contact_value + id);
          return Array.from(new Set([...prev, ...newEmails]));
        });

        setSelectedPhones((prev) => {
          const newPhones = item.phone_data.map((phone) => phone.contact_value + id);
          return Array.from(new Set([...prev, ...newPhones]));
        });
      } else if (!isChecked && id && selectedContacts[id]) {
        delete tempSelectedObj[id];
        const contactValuesSet = new Set(item.email_data.map((obj) => obj.contact_value + id));
        const phoneValuesSet = new Set(item.phone_data.map((obj) => obj.contact_value + id));
        setSelectedEmails(selectedEmails.filter((email) => !contactValuesSet.has(email)));
        setSelectedPhones(selectedPhones.filter((phone) => !phoneValuesSet.has(phone)));
      }
    } else {
      let id = item?.contact_id;

      if (isChecked && id && !selectedContacts[id]) {
        tempSelectedObj[id] = JSON.parse(JSON.stringify(item));
      } else if (!isChecked && id && selectedContacts[id]) {
        delete tempSelectedObj[id];
      }
    }

    setSelectedContacts(JSON.parse(JSON.stringify(tempSelectedObj)));
  };

  const getAIDashboardContacts = async (text, tempDateRange, type) => {
    setAIContactData([]);
    setIsLoading(true);
    try {
      let payload = {
        search: text,
      };
      if (tempDateRange?.from && tempDateRange?.to) {
        payload.from_date = tempDateRange.from;
        payload.to_date = tempDateRange.to;
      }
      if (type === "pagination") {
        payload.must_not = aiContactsMustData;
      }
      const { data } = await axios.post(getApiUrl("getFavouriteAIContacts"), payload);
      if (data.data) {
        setAIContactData(JSON.parse(JSON.stringify(data.data)));
        setTotalCompanyCount(data.total_companies);
        if (type === "pagination") {
          setAIContactsMustData((prev) => [...prev, ...data.must_not]);
        } else {
          setAIContactsMustData(data.must_not);
        }
        if (!payload.from_date || !payload.to_date) {
          setAIDateRange(JSON.parse(JSON.stringify({ from: data.from_date, to: data.to_date })));
          setSelectedAIDateRange(JSON.parse(JSON.stringify({ from: data.from_date, to: data.to_date })));
        }
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    dispatch(getSidebarCountData());
  }, []);
  useEffect(() => {
    if (type === mainContactTabs.ai) {
      getAIDashboardContacts("", selectedAIDateRange);
      setDataPerPage(10);
    } else if (type === mainContactTabs.company) {
      getDashboardContacts("", 0, selectedDateRange);

      setDataPerPage(6);
    }
    setSelectedEmails([]);
    setSelectedPhones([]);
    setSelectedContacts({});
    setCurrentPage(1);
    setSearchedContact("");
  }, [type]);

  const checkIfAllSelected = () => {
    if (type === mainContactTabs.company) {
      let isAllSelected = true;
      contactsData.slice((currentPage - 1) * dataPerPage, currentPage * dataPerPage).forEach((contact) => {
        if (!selectedContacts[contact.contact_id]) {
          isAllSelected = false;
        }
      });
      return isAllSelected;
    } else {
      let isAllSelected = true;
      aiContactData.slice((currentPage - 1) * dataPerPage, currentPage * dataPerPage).forEach((contact) => {
        if (!selectedContacts[contact.company_id]) {
          isAllSelected = false;
        }
      });
      return isAllSelected;
    }
  };

  const downloadContacts = (isDownloadAll) => {
    let file_name = "AddressBookContact_" + moment().format("DD-MM-YYYY") + "_" + new Date().getTime();
    axios
      .post(
        intelAPIEndpoints.getDownloadAllContactInAddressBook,
        {
          bulk_download: isDownloadAll ? true : false,
          from_date: selectedDateRange.from,
          to_date: selectedDateRange.to,
          search: searchedContact,
          contacts: !isDownloadAll ? Object.values(selectedContacts) : [],
        },
        {
          responseType: "blob",
        }
      )
      .then((response) => {
        const contentTypeHeader = response.headers["content-type"];
        const file = new Blob([response.data], { type: contentTypeHeader });
        const url = window.URL.createObjectURL(file);
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.href = url;
        a.download = file_name + ".xlsx";
        a.click();
      })
      .catch(() => {
        toast.error("Something went wrong, Please try after sometime !!!");
      });
  };

  const downloadAIContacts = (isDownloadAll) => {
    const addedContacts = [];
    for (const companyId in selectedContacts) {
      const companyData = selectedContacts[companyId];
      selectedEmails.forEach((email) => {
        const data = companyData.email_data.find((e) => e.contact_value + companyId === email);
        if (data) {
          addedContacts.push({
            name: data?.name ?? "",
            email: data?.contact_value,
            contact_type: "email",
            company_name: companyData?.company_name,
            company_id: companyData?.company_id,
          });
        }
      });
      selectedPhones.forEach((phone) => {
        const data = companyData.phone_data.find((e) => e.contact_value + companyId === phone);
        if (data) {
          addedContacts.push({
            name: data?.name ?? "",
            phone: data?.contact_value,
            contact_type: "phone",
            company_name: companyData.company_name,
            company_id: companyData.company_id,
          });
        }
      });
    }
    let file_name = "AddressBook" + moment().format("DD-MM-YYYY") + "_" + new Date().getTime() + ".xlsx";
    const requestObject = {
      bulk_download: isDownloadAll ? true : false,
      from_date: aiDateRange.from,
      to_date: aiDateRange.to,
      search: searchedContact,
      isFromDashboard: true,
      file_name: file_name,
    };
    if (addedContacts.length > 0) requestObject.data = addedContacts;
    axios
      .post(getApiUrl("CompanyContactDetails/downloadAiAddressbookOfUser"), requestObject, {
        responseType: "blob",
      })
      .then((response) => {
        const contentTypeHeader = response.headers["content-type"];
        const file = new Blob([response.data], { type: contentTypeHeader });
        const url = window.URL.createObjectURL(file);
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.href = url;
        a.download = file_name;
        a.click();
      })
      .catch((err) => {
        captureException(err);
        toast.error("Something went wrong, Please try after sometime !!!");
      });
  };

  const handleSelectAll = (isChecked) => {
    let tempSelectedObj = JSON.parse(JSON.stringify(selectedContacts));
    if (type === mainContactTabs.ai) {
      let tempContactData = JSON.parse(JSON.stringify(aiContactData.slice((currentPage - 1) * dataPerPage, currentPage * dataPerPage)));
      if (isChecked) {
        tempContactData.forEach((contact) => {
          if (!tempSelectedObj[contact.company_id]) {
            tempSelectedObj[contact.company_id] = JSON.parse(JSON.stringify(contact));
          }
          setSelectedEmails((prev) => {
            const newEmails = contact.email_data.map((email) => email.contact_value + contact.company_id);
            return Array.from(new Set([...prev, ...newEmails]));
          });

          setSelectedPhones((prev) => {
            const newPhones = contact.phone_data.map((phone) => phone.contact_value + contact.company_id);
            return Array.from(new Set([...prev, ...newPhones]));
          });
        });
      } else {
        tempContactData.forEach((contact) => {
          if (tempSelectedObj[contact.company_id]) {
            delete tempSelectedObj[contact.company_id];
            const emailData = contact.email_data;
            const phoneData = contact.phone_data;

            emailData.forEach((email) => {
              if (selectedEmails.includes(email.contact_value + contact.company_id)) {
                let index = selectedEmails.indexOf(email.contact_value + contact.company_id);
                selectedEmails.splice(index, 1);
              }
            });

            phoneData.forEach((phone) => {
              if (selectedPhones.includes(phone.contact_value + contact.company_id)) {
                let index = selectedPhones.indexOf(phone.contact_value + contact.company_id);
                selectedPhones.splice(index, 1);
              }
            });

            setSelectedEmails(selectedEmails);
            setSelectedPhones(selectedPhones);
          }
        });
      }
    } else {
      let tempContactData = JSON.parse(JSON.stringify(contactsData.slice((currentPage - 1) * dataPerPage, currentPage * dataPerPage)));
      if (isChecked) {
        tempContactData.forEach((contact) => {
          if (!tempSelectedObj[contact.contact_id]) {
            tempSelectedObj[contact.contact_id] = JSON.parse(JSON.stringify(contact));
          }
        });
      } else {
        tempContactData.forEach((contact) => {
          if (tempSelectedObj[contact.contact_id]) {
            delete tempSelectedObj[contact.contact_id];
          }
        });
      }
    }
    setSelectedContacts(JSON.parse(JSON.stringify(tempSelectedObj)));
  };

  const debounceCall = (text) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      setSelectedContacts({});
      setSelectedEmails([]);
      setSelectedPhones([]);
      setCurrentPage(1);
      if (type === mainContactTabs.company) {
        getDashboardContacts(text, 0, selectedDateRange);
      } else if (type === mainContactTabs.ai) {
        getAIDashboardContacts(text, selectedAIDateRange);
      }
    }, 500);
  };

  const handleSearch = (text) => {
    setSearchedContact(text);
    debounceCall(text);
  };

  const handlePageChange = (pageNo) => {
    if (type === mainContactTabs.ai) {
      if (totalCompanyCount > aiContactData.length && pageNo * dataPerPage > aiContactData.length) {
        getAIDashboardContacts(searchedContact, selectedAIDateRange, "pagination");
      }
    } else if (type === mainContactTabs.company) {
      if (contactsCount > contactsData.length && pageNo * dataPerPage > contactsData.length) {
        getDashboardContacts(searchedContact, contactsData.length, selectedDateRange);
      }
    }
    setCurrentPage(pageNo);
  };

  const handleDateChange = (dateRange) => {
    setSelectedContacts({});
    setSelectedEmails([]);
    setSelectedPhones([]);
    let tempDateRange = { from: moment(dateRange.startDate).format("YYYY-MM-DD"), to: moment(dateRange.endDate).format("YYYY-MM-DD") };
    setCurrentPage(1);
    if (type === mainContactTabs.company) {
      setSelectedDateRange(tempDateRange);
      getDashboardContacts(searchedContact, 0, tempDateRange);
    } else if (type === mainContactTabs.ai) {
      setSelectedAIDateRange(tempDateRange);
      getAIDashboardContacts(searchedContact, tempDateRange);
    }
  };

  const exportContactsToSalesforce = () => {
    const requestObject = JSON.parse(JSON.stringify(Object.keys(selectedContacts)));
    axios
      .post(intelAPIEndpoints.sendContacttoSalesforce, { contact_id: requestObject })
      .then((res) => {
        if (res?.data?.data) {
          if (res?.data?.status?.toLowerCase() === "success") {
            if (res?.data?.data?.description?.toLowerCase() === "Successfully!".toLowerCase()) {
              toast.success(res.data.data.message || "Successfully exported to Salesforce!");
            } else if (res.data.data.message && typeof res.data.data.message === "string" && res.data.data.message.toLowerCase() === "salesforce_error") {
              toast.error(res?.data?.data?.description || "Error while exporting to Salesforce. Please try again!");
            } else if (res?.data?.data?.description?.toLowerCase() !== "All Contact are Duplicate!".toLowerCase()) {
              setShowSalesForceDuplicateModal(true);
              setDuplicateSalesforceData({ count: JSON.parse(res.data.data?.message).Duplicate_Contact.length, data: JSON.parse(res.data.data.message).Duplicate_Contact });
            } else if (res?.data?.data?.description.toLowerCase() !== "Rest all Contact Created!".toLowerCase()) {
              setShowSalesForceDuplicateModal(true);
              setDuplicateSalesforceData({ count: JSON.parse(res.data.data?.message).Duplicate_Contact.length, data: JSON.parse(res.data.data.message).Duplicate_Contact });
            }
          } else {
            toast.error("Something went wrong. Please try again after sometime!!!");
          }
        } else {
          toast.error("Something went wrong. Please try again after sometime!!!");
        }
      })
      .catch(() => {
        toast.error("Something went wrong. Please try again after sometime!!!");
      });
  };

  const exportContactsToHubspot = () => {
    const requestObject = JSON.parse(JSON.stringify(Object.keys(selectedContacts)));
    axios
      .post(intelAPIEndpoints.sendContacttoHubspot, { contact_id: requestObject })
      .then((res) => {
        if (res?.data?.data) {
          if (res?.data?.status?.toLowerCase() === "success") {
            if (res?.data?.data?.status?.toLowerCase() === "complete".toLowerCase()) {
              toast.success("Contact sent successfully to Hubspot");
            } else if (typeof res?.data?.data?.status === "string" && res?.data?.data?.status?.toLowerCase() === "error") {
              toast.error(res?.data?.data?.message || "Error while exporting to Hubspot. Please try again!");
            }
          } else {
            toast.error("Something went wrong. Please try again after sometime!!!");
          }
        } else {
          toast.error("Something went wrong. Please try again after sometime!!!");
        }
      })
      .catch(() => {
        toast.error("Something went wrong. Please try again after sometime!!!");
      });
  };

  const exportContactsToZoho = () => {
    const requestObject = JSON.parse(JSON.stringify(Object.keys(selectedContacts)));
    axios
      .post(intelAPIEndpoints.sendContacttoZoho, { contact_id: requestObject })
      .then((res) => {
        if (res?.data?.data) {
          if (res.data.status.toLowerCase() === "success") {
            if (res?.data?.data?.status?.toLowerCase() === "complete".toLowerCase()) {
              toast.success("Contact sent successfully to Zoho");
            } else if (typeof res?.data?.data?.status === "string" && res?.data?.data?.status.toLowerCase() === "error") {
              toast.error(res?.data?.data?.message || "Error while exporting to Zoho. Please try again!");
            }
          } else {
            toast.error("Something went wrong. Please try again after sometime!!!");
          }
        } else {
          toast.error("Something went wrong. Please try again after sometime!!!");
        }
      })
      .catch(() => {
        toast.error("Something went wrong. Please try again after sometime!!!");
      });
  };
  return (
    <IntelLayout
      type="addressBook"
      pageTitle="Viewed Contacts | Trademo Intel"
      setNotification={(val) => {
        setShowNotification(val);
      }}
      showNotification={showNotification}>
      <div className={`${styles.contact_body} bg-white pr-2`}>
        <div className={styles.header}>
          <TabComponent setType={setType} />
        </div>
        <div className={styles.navbar}>
          {isLoading && !dateRange.from ? (
            <LoadingSkeleton lines={1} lineHeight="36px" width="365px" shape="rectangle" />
          ) : (
            <>
              <div className={styles.button_container}>
                {((dateRange.from && dateRange.to && type === mainContactTabs.company) || (aiDateRange.from && aiDateRange.to && type === mainContactTabs.ai)) && (
                  <>
                    <svg className={styles.search_input_icon} fill="#101828" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 -960 960 960" width="16">
                      <path d="M796-121 533-384q-30 26-69.959 40.5T378-329q-108.162 0-183.081-75Q120-479 120-585t75-181q75-75 181.5-75t181 75Q632-691 632-584.85 632-542 618-502q-14 40-42 75l264 262-44 44ZM377-389q81.25 0 138.125-57.5T572-585q0-81-56.875-138.5T377-781q-82.083 0-139.542 57.5Q180-666 180-585t57.458 138.5Q294.917-389 377-389Z" />
                    </svg>
                    <input className={styles.search_input} placeholder={type === mainContactTabs.company ? "Search by company, employee name, department" : "Search by company, employee, email address"} value={searchedContact} onChange={(e) => handleSearch(e.target.value)} />
                  </>
                )}
                {dateRange.from && dateRange.to && type === mainContactTabs.company && (
                  <span className={styles.date_picker_container}>
                    <svg className={styles.calendar_icon} xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 -960 960 960" width="16">
                      <path d="M180-80q-24 0-42-18t-18-42v-620q0-24 18-42t42-18h65v-60h65v60h340v-60h65v60h65q24 0 42 18t18 42v620q0 24-18 42t-42 18H180Zm0-60h600v-430H180v430Zm0-490h600v-130H180v130Zm0 0v-130 130Zm300 230q-17 0-28.5-11.5T440-440q0-17 11.5-28.5T480-480q17 0 28.5 11.5T520-440q0 17-11.5 28.5T480-400Zm-160 0q-17 0-28.5-11.5T280-440q0-17 11.5-28.5T320-480q17 0 28.5 11.5T360-440q0 17-11.5 28.5T320-400Zm320 0q-17 0-28.5-11.5T600-440q0-17 11.5-28.5T640-480q17 0 28.5 11.5T680-440q0 17-11.5 28.5T640-400ZM480-240q-17 0-28.5-11.5T440-280q0-17 11.5-28.5T480-320q17 0 28.5 11.5T520-280q0 17-11.5 28.5T480-240Zm-160 0q-17 0-28.5-11.5T280-280q0-17 11.5-28.5T320-320q17 0 28.5 11.5T360-280q0 17-11.5 28.5T320-240Zm320 0q-17 0-28.5-11.5T600-280q0-17 11.5-28.5T640-320q17 0 28.5 11.5T680-280q0 17-11.5 28.5T640-240Z" />
                    </svg>
                    <DateRangePickerSelfComponent
                      initialSettings={{
                        startDate: moment(selectedDateRange?.from),
                        endDate: moment(selectedDateRange?.to),
                        maxDate: moment(dateRange?.to),
                        minDate: moment(dateRange?.from),
                        linkedCalendars: false,
                        showDropdowns: true,
                        alwaysShowCalendars: true,
                        applyButtonClasses: "btn btn-primary btn-sm trademo-new-btn",
                        cancelButtonClasses: "btn btn-outline-secondary trademo-outline-btn btn-sm py-2",
                        ranges: DateRangeOptions,
                        opens: "right",
                        locale: {
                          format: "MMM D, YYYY",
                          separator: " - ",
                        },
                      }}
                      customClassName={styles.date_picker}
                      onApply={(e) => handleDateChange(e)}
                    />
                  </span>
                )}
                {aiDateRange.from && aiDateRange.to && type === mainContactTabs.ai && (
                  <span className={styles.date_picker_container}>
                    <svg className={styles.calendar_icon} xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 -960 960 960" width="16">
                      <path d="M180-80q-24 0-42-18t-18-42v-620q0-24 18-42t42-18h65v-60h65v60h340v-60h65v60h65q24 0 42 18t18 42v620q0 24-18 42t-42 18H180Zm0-60h600v-430H180v430Zm0-490h600v-130H180v130Zm0 0v-130 130Zm300 230q-17 0-28.5-11.5T440-440q0-17 11.5-28.5T480-480q17 0 28.5 11.5T520-440q0 17-11.5 28.5T480-400Zm-160 0q-17 0-28.5-11.5T280-440q0-17 11.5-28.5T320-480q17 0 28.5 11.5T360-440q0 17-11.5 28.5T320-400Zm320 0q-17 0-28.5-11.5T600-440q0-17 11.5-28.5T640-480q17 0 28.5 11.5T680-440q0 17-11.5 28.5T640-400ZM480-240q-17 0-28.5-11.5T440-280q0-17 11.5-28.5T480-320q17 0 28.5 11.5T520-280q0 17-11.5 28.5T480-240Zm-160 0q-17 0-28.5-11.5T280-280q0-17 11.5-28.5T320-320q17 0 28.5 11.5T360-280q0 17-11.5 28.5T320-240Zm320 0q-17 0-28.5-11.5T600-280q0-17 11.5-28.5T640-320q17 0 28.5 11.5T680-280q0 17-11.5 28.5T640-240Z" />
                    </svg>
                    <DateRangePickerSelfComponent
                      initialSettings={{
                        startDate: moment(selectedAIDateRange?.from),
                        endDate: moment(selectedAIDateRange?.to),
                        maxDate: moment(aiDateRange?.to),
                        minDate: moment(aiDateRange?.from),
                        linkedCalendars: false,
                        showDropdowns: true,
                        alwaysShowCalendars: true,
                        applyButtonClasses: "btn btn-primary btn-sm trademo-new-btn",
                        cancelButtonClasses: "btn btn-outline-secondary trademo-outline-btn btn-sm py-2",
                        ranges: DateRangeOptions,
                        opens: "right",
                        locale: {
                          format: "MMM D, YYYY",
                          separator: " - ",
                        },
                      }}
                      customClassName={styles.date_picker}
                      onApply={(e) => handleDateChange(e)}
                    />
                  </span>
                )}
              </div>
              <div>
                {selectedContacts && ((type === mainContactTabs.company && contactsData.length > 0) || (type === mainContactTabs.ai && aiContactsMustData.length > 0)) && Object.keys(selectedContacts) && Object.keys(selectedContacts).length === 0 && (
                  <button
                    className={styles.download_button}
                    type="button"
                    onClick={() => {
                      if (type === mainContactTabs.ai) {
                        downloadAIContacts(true);
                        trademoTrackingEvents(trackingEventDictionary.dashboardContactsListAIFetchedContactsDowloadAllContacts, { ...generateTrackingObject(location.pathname) });
                      } else {
                        downloadContacts(true);
                        trademoTrackingEvents(trackingEventDictionary.dashboardContactListDownloadAllContacts, { ...generateTrackingObject(location.pathname) });
                      }
                    }}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="#fff" height="16" viewBox="0 -960 960 960" width="16">
                      <path d="M251-160q-88 0-149.5-61.5T40-371q0-79 50.5-137.5T217-579q15-84 82-148.5T451-792q24 0 42 13.5t18 36.5v294l83-83 43 43-156 156-156-156 43-43 83 83v-289q-86 11-135 75.5T267-522h-19q-61 0-104.5 43T100-371q0 65 45 108t106 43h500q45 0 77-32t32-77q0-45-32-77t-77-32h-63v-84q0-68-33-117.5T570-718v-65q81 29 129.5 101T748-522v24q72-2 122 46t50 123q0 69-50 119t-119 50H251Zm229-347Z" />
                    </svg>
                    Download All Contacts
                  </button>
                )}
              </div>
            </>
          )}
        </div>

        <>
          <div className={styles.selection_bar}>
            <div className="d-flex align-items-center">
              {isLoading ? (
                <LoadingSkeleton lines={1} lineHeight="36px" width="100px" shape="rectangle" />
              ) : type === mainContactTabs.company ? (
                contactsData.slice((currentPage - 1) * dataPerPage, currentPage * dataPerPage).length ? (
                  <>
                    <label className="form-check d-flex align-items-center ml-1">
                      <input className="form-check-input" type="checkbox" checked={checkIfAllSelected()} onChange={(e) => handleSelectAll(e.target.checked)} />
                    </label>
                    <span>Select All</span>
                  </>
                ) : (
                  <></>
                )
              ) : type === mainContactTabs.ai ? (
                aiContactData.slice((currentPage - 1) * dataPerPage, currentPage * dataPerPage).length ? (
                  <>
                    <label className="form-check d-flex align-items-center ml-1">
                      <input className="form-check-input" type="checkbox" checked={checkIfAllSelected()} onChange={(e) => handleSelectAll(e.target.checked)} />
                    </label>
                    <span>Select All</span>
                  </>
                ) : (
                  <></>
                )
              ) : (
                <></>
              )}
              {(Object.keys(selectedContacts).length > 0 || selectedEmails.length > 0 || selectedPhones.length > 0) && (
                <div className={styles.selected_row}>
                  <span className={styles.selected_count}>
                    {type === mainContactTabs.company ? <span className={styles.num_box}>{Object.keys(selectedContacts).length}</span> : <span className={styles.num_box}>{Object.keys(selectedEmails).length + Object.keys(selectedPhones).length}</span>} Contact{Object.keys(selectedContacts).length > 1 && "s"} selected
                  </span>
                  <span
                    onClick={() => {
                      if (type === mainContactTabs.ai) {
                        downloadAIContacts();
                        trademoTrackingEvents(trackingEventDictionary.dashboardContactsListAIFetchedContactsDowloadContacts, { ...generateTrackingObject(location.pathname) });
                      } else {
                        downloadContacts();
                        trademoTrackingEvents(trackingEventDictionary.dashboardContactListDownloadContacts, { ...generateTrackingObject(location.pathname) });
                      }
                    }}
                    className={`cursor-pointer ${styles.download_button}`}>
                    <svg className={styles.selected_icon} xmlns="http://www.w3.org/2000/svg" fill="#5a1ce2" height="16" viewBox="0 -960 960 960" width="16">
                      <path d="M251-160q-88 0-149.5-61.5T40-371q0-79 50.5-137.5T217-579q15-84 82-148.5T451-792q24 0 42 13.5t18 36.5v294l83-83 43 43-156 156-156-156 43-43 83 83v-289q-86 11-135 75.5T267-522h-19q-61 0-104.5 43T100-371q0 65 45 108t106 43h500q45 0 77-32t32-77q0-45-32-77t-77-32h-63v-84q0-68-33-117.5T570-718v-65q81 29 129.5 101T748-522v24q72-2 122 46t50 123q0 69-50 119t-119 50H251Zm229-347Z" />
                    </svg>
                    Download
                  </span>
                  {is_hubspot_active && type === mainContactTabs.company && (
                    <span
                      onClick={() => {
                        trademoTrackingEvents(trackingEventDictionary.dashboardContactListExportHubspot, { ...generateTrackingObject(location.pathname) });
                        exportContactsToHubspot();
                      }}
                      className={`cursor-pointer ${styles.export_crm}`}>
                      <svg className={styles.selected_icon} xmlns="http://www.w3.org/2000/svg" fill="#5a1ce2" height="16" viewBox="0 -960 960 960" width="16">
                        <path d="M180-120q-24 0-42-18t-18-42v-210h60v210h600v-600H180v210h-60v-210q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm233-167-45-45 118-118H120v-60h366L368-628l45-45 193 193-193 193Z" />
                      </svg>
                      Export to Hubspot
                    </span>
                  )}
                  {is_salesforce_active && type === mainContactTabs.company && (
                    <span
                      onClick={() => {
                        trademoTrackingEvents(trackingEventDictionary.dashboardContactListExportSalesforce, { ...generateTrackingObject(location.pathname) });
                        exportContactsToSalesforce();
                      }}
                      className={`cursor-pointer ${styles.export_crm}`}>
                      {" "}
                      <svg className={styles.selected_icon} xmlns="http://www.w3.org/2000/svg" fill="#5a1ce2" height="16" viewBox="0 -960 960 960" width="16">
                        <path d="M180-120q-24 0-42-18t-18-42v-210h60v210h600v-600H180v210h-60v-210q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm233-167-45-45 118-118H120v-60h366L368-628l45-45 193 193-193 193Z" />
                      </svg>
                      Export to Salesforce
                    </span>
                  )}
                  {is_zoho_active && type === mainContactTabs.company && (
                    <span
                      onClick={() => {
                        trademoTrackingEvents(trackingEventDictionary.dashboardContactListExportZoho, { ...generateTrackingObject(location.pathname) });
                        exportContactsToZoho();
                      }}
                      className={`cursor-pointer ${styles.export_crm}`}>
                      {" "}
                      <svg className={styles.selected_icon} xmlns="http://www.w3.org/2000/svg" fill="#5a1ce2" height="16" viewBox="0 -960 960 960" width="16">
                        <path d="M180-120q-24 0-42-18t-18-42v-210h60v210h600v-600H180v210h-60v-210q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm233-167-45-45 118-118H120v-60h366L368-628l45-45 193 193-193 193Z" />
                      </svg>
                      Export to Zoho
                    </span>
                  )}
                  <span
                    className={`cursor-pointer`}
                    onClick={() => {
                      setSelectedContacts({});
                      setSelectedEmails([]);
                      setSelectedPhones([]);
                    }}>
                    <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 -960 960 960" width="16">
                      <path d="M249-193.434 193.434-249l231-231-231-231L249-766.566l231 231 231-231L766.566-711l-231 231 231 231L711-193.434l-231-231-231 231Z" />
                    </svg>
                  </span>
                </div>
              )}
            </div>
            {contactCredits.totalCredit > 0 && contactCredits.usedCredit >= 0 && type === mainContactTabs.company && (
              <div>
                <span className="font-weight-bold">{commaFormat(contactCredits.totalCredit - contactCredits.usedCredit)} </span> of <span> {commaFormat(contactCredits.totalCredit)} </span> download credits remaining
                <CircularProgressbar value={((contactCredits.totalCredit - contactCredits.usedCredit) / contactCredits.totalCredit) * 100} strokeWidth={15} className={styles.circular_progress_bar} />
              </div>
            )}
          </div>
          {type === mainContactTabs.company ? (
            <div className={`${isLoading && styles.contacts_card_container_loading} ${styles.contacts_card_container}`}>
              {isLoading ? (
                <LoadingSkeleton lines={6} lineHeight="334px" width="100%" shape="rectangle" />
              ) : contactsData.length > 0 ? (
                contactsData.slice((currentPage - 1) * dataPerPage, currentPage * dataPerPage).map((item, index) => {
                  return (
                    <div key={item?.contact_id} className={styles.contacts_card}>
                      <div>
                        <div className={styles.card_header}>
                          <div className={styles.name_container}>
                            {item.profilePicUrl ? (
                              <img src={item.profilePicUrl} className={styles.name_image} alt={getInitials(item.fullName)} />
                            ) : (
                              <div style={{ backgroundColor: avatarBgColors[index % dataPerPage] }} className={styles.name_icon}>
                                {(item.fullName && getInitials(item.fullName)) || "NA"}
                              </div>
                            )}
                            <div className={styles.name}>
                              {(item.fullName && formatStringCase(item.fullName.slice(0, 45), false, true)) || "NA"}
                              {item?.fullName?.length > 45 && "..."}
                              {item.companyName && <div className={styles.companyName}>{!item.redirectionType || !item.redirectionType?.trim() || item.redirectionType?.toLowerCase() === "importers" || item.redirectionType?.toLowerCase() === "exporters" ? <TabelRedirectionColumn tabType={"company"} dataSource={[{ key: item.data_source + " " + item.trade_direction + "s" }]} companyId={item.companyId} companyName={item.companyName} subCategory={item?.redirectionType} isRedirect={true} isRedirectCallingSlug={true} fromDashboard /> : <RedirectProfile profileType={getRedirectProfileType(item?.redirectionType?.trim())} profileId={item.companyId} profileName={item.companyName} dataSource={`${item.data_source}-${item.trade_direction}s`} countryName={item.data_source} countryType={item.trade_direction} fromDashboard />}</div>}
                            </div>
                          </div>
                          <div className="d-flex">
                            <label className="form-check">
                              <input className={`form-check-input ${styles.input_css}`} type="checkbox" onChange={(e) => handleSelection(item, e.target.checked)} checked={item?.contact_id && selectedContacts[item.contact_id] ? true : false} />
                            </label>
                          </div>
                        </div>
                        {(item.jobProfile || item.seniority || item.department || item?.location) && (
                          <div className={styles.profile_header}>
                            {item.jobProfile && (
                              <div className={`${styles.contact_data} `}>
                                <span className={styles.contact_data_label}>Job Title</span>
                                <span data-for={`job_profile${item.contact_id}`} data-tip={item.jobProfile.length > 30 ? getTitleCase(item.jobProfile) : ""} className={styles.contact_data_value}>
                                  {formatStringCase(item.jobProfile.slice(0, 30), false, true)}
                                  {item.jobProfile.length > 30 && "..."}
                                </span>
                                <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" id={`job_profile${item.contact_id}`} />
                              </div>
                            )}
                            {item.seniority && (
                              <div className={styles.contact_data}>
                                <span className={styles.contact_data_label}>Management Level</span>
                                <span data-for={`management_level${item.contact_id}`} data-tip={item.seniority.length > 30 ? getTitleCase(item.seniority) : ""} className={styles.contact_data_value}>
                                  {formatStringCase(item.seniority.slice(0, 30), false, true)}
                                  {item.seniority.length > 30 && "..."}
                                </span>
                                <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" id={`management_level${item.contact_id}`} />
                              </div>
                            )}
                            {item.department && (
                              <div className={styles.contact_data}>
                                <span className={styles.contact_data_label}>Department</span>
                                <span data-for={`department${item.contact_id}`} data-tip={item.department.length > 30 ? getTitleCase(item.department) : ""} className={styles.contact_data_value}>
                                  {formatStringCase(item.department.slice(0, 30), false, true)}
                                  {item.department.length > 30 && "..."}
                                </span>
                                <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" id={`department${item.contact_id}`} />
                              </div>
                            )}
                            {item?.location && (
                              <div className={styles.contact_data}>
                                <span className={styles.contact_data_label}>Country</span>
                                <span data-for={`location${item?.location}`} data-tip={item?.location?.length > 30 ? getTitleCase(item?.location) : ""} className={styles.contact_data_value}>
                                  {formatStringCase(item?.location?.slice(0, 30), false, true)}
                                  {item?.location?.length > 30 && "..."}
                                </span>
                                <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" id={`location${item?.location}`} />
                              </div>
                            )}
                          </div>
                        )}
                        {((item.email && Array.isArray(item.email) && item.email?.[0]) || (item.phone && Array.isArray(item.phone) && item.phone?.[0]) || (item.linkedin_url && item.isLinkedInViewed)) && (
                          <>
                            <div className={styles.subHeader}>Contact info</div>
                            {item.email && Array.isArray(item.email) && item.email?.[0] && (
                              <div className={styles.contact_email}>
                                <svg className={styles.contacts_icon} xmlns="http://www.w3.org/2000/svg" fill="#667085" height="12" viewBox="0 -960 960 960" width="14">
                                  <path d="M145.087-145.869q-32.507 0-55.862-23.356-23.356-23.355-23.356-55.862v-509.826q0-32.74 23.356-56.262 23.355-23.521 55.862-23.521h669.826q32.74 0 56.262 23.521 23.521 23.522 23.521 56.262v509.826q0 32.507-23.521 55.862-23.522 23.356-56.262 23.356H145.087ZM480-443.912l334.913-223v-68.001L480-516.913l-334.913-218v68.001l334.913 223Z" />
                                </svg>
                                {item.email?.[0]}
                                {item.email.length > 1 && (
                                  <>
                                    <span data-for={`email_count${item.contact_id}`} data-tip={item.email.slice(1).join(", ")} className={styles.email_count}>
                                      +{item.email.length - 1}
                                    </span>
                                    <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" id={`email_count${item.contact_id}`} />
                                  </>
                                )}
                              </div>
                            )}
                            {item.phone && Array.isArray(item.phone) && item.phone?.[0] && (
                              <div className={styles.contact_email}>
                                <svg className={styles.contacts_icon} fill="#667085" xmlns="http://www.w3.org/2000/svg" height="12" viewBox="0 -960 960 960" width="14">
                                  <path d="M796.13-105.869q-119.391 0-242.435-57.13-123.043-57.131-227.739-161.827-105.261-105.261-162.674-228.587-57.413-123.326-57.413-242.152 0-24.653 16.957-41.892 16.956-17.239 41.609-17.239h140q23.609 0 38.979 13.674 15.37 13.674 21.065 37.718l27 116.956q3.131 20.783-1.065 37.087-4.196 16.305-16.718 27.696l-102.261 97.609q23.739 39.478 50.478 74.086 26.739 34.609 60.044 66.348 34.739 36.304 71.499 64.695 36.761 28.392 76.109 49l97.826-99.696q13.957-14.956 31.479-20.087 17.521-5.13 36.739-.869l107.695 24.304q24.044 6.826 37.718 23.348 13.674 16.522 13.674 40.001v138.391q0 24.653-17.239 41.609-17.239 16.957-41.327 16.957Z" />
                                </svg>
                                {item.phone?.[0]}
                                {item.phone.length > 1 && (
                                  <>
                                    <span data-for={`phone_num_count${item.contact_id}`} data-tip={item.phone.slice(1).join(", ")} className={styles.phone_num_count}>
                                      +{item.phone.length - 1}
                                    </span>
                                    <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" id={`phone_num_count${item.contact_id}`} />
                                  </>
                                )}
                              </div>
                            )}
                            {item.linkedin_url && item.isLinkedInViewed && (
                              <div className={styles.contact_phone}>
                                <div>
                                  <img src={LinkedIn} alt="linkedin" className={styles.contacts_icon} />
                                </div>
                                <a href={item.linkedin_url} className={styles.trademo_link} target="_blank" rel="noreferrer">
                                  {item.linkedin_url}
                                </a>
                              </div>
                            )}
                          </>
                        )}
                      </div>
                      {item.creation_date && <div className={styles.contact_creation_date}>Added on {moment(item.creation_date).format("MMM DD, YYYY")}</div>}
                    </div>
                  );
                })
              ) : (
                <div className="text-center mt-4 d-flex flex-column justify-content-center w-100">
                  <div className="py-2">
                    <img src={CLOUDINARY_INTEL_BASE_URL + "/v1656309287/intel/dashboard%202.0/illustration_addressbook_mqbd2m.svg"} className="img-fluid" />
                  </div>
                  <div>
                    {dateRange.from && dateRange.to ? (
                      <b>No results match your search criteria for the selected date range.</b>
                    ) : (
                      <div className="d-flex justify-content-center align-items-center w-50 m-auto">
                        <div className={`w-100 ${styles.no_contact_text} d-flex flex-column align-items-start`}>
                          <span>You have not added contact for any company. There are multiple ways to add contacts</span>
                          <div className="py-2">
                            <ol className="text-left" type="1">
                              <li className="py-1">Visit any Company Profile and click on the Contact Details option.</li>
                              <li className="py-1">Go to Companies section from the Left Navigation. Select companies that you added, click on Fetch Contacts Option.</li>
                              <li className="py-1">Go to Search section from the Left Navigation. From Unique Importer or Exporters select companies that you are interested in, click on Fetch Contacts Option.</li>
                            </ol>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          ) : isLoading ? (
            <div className={`${isLoading && styles.ai_contacts_card_container_loading} ${styles.contacts_card_container}`}>
              <LoadingSkeleton lines={6} lineHeight="334px" width="100%" shape="rectangle" />
            </div>
          ) : aiContactData.length > 0 ? (
            type === mainContactTabs.ai && <AIFetchedContacts currentPage={currentPage} selectedContacts={selectedContacts} aifetchedData={aiContactData} handleSelection={handleSelection} dataPerPage={dataPerPage} handleCheckboxChange={handleCheckboxChange} selectedEmails={selectedEmails} setSelectedEmails={setSelectedEmails} selectedPhones={selectedPhones} setSelectedPhones={setSelectedPhones} />
          ) : (
            <div className="text-center mt-4 d-flex flex-column justify-content-center w-100">
              <div className="py-2">
                <img src={CLOUDINARY_INTEL_BASE_URL + "/v1656309287/intel/dashboard%202.0/illustration_addressbook_mqbd2m.svg"} className="img-fluid" />
              </div>
              <div>
                {aiDateRange.from && aiDateRange.to ? (
                  <b>No results match your search criteria for the selected date range.</b>
                ) : (
                  <div className="d-flex justify-content-center align-items-center w-50 m-auto">
                    <div className={`w-100 ${styles.no_contact_text} d-flex flex-column align-items-start`}>
                      <span>You have not added contact for any company. There are multiple ways to add contacts</span>
                      <div className="py-2">
                        <ol className="text-left" type="1">
                          <li className="py-1">Visit any Company Profile and click on the Contact Details option.</li>
                          <li className="py-1">Go to Companies section from the Left Navigation. Select companies that you added, click on Fetch Contacts Option.</li>
                          <li className="py-1">Go to Search section from the Left Navigation. From Unique Importer or Exporters select companies that you are interested in, click on Fetch Contacts Option.</li>
                        </ol>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          {((type === mainContactTabs.ai && totalCompanyCount > dataPerPage) || (type === mainContactTabs.company && contactsCount > dataPerPage)) && (
            <div className="col-12 pt-3 pb-2 trademo-pagination trademo-contact-pagination">
              <Pagination prevPageText={<ChevronLeft size={18} />} nextPageText={<ChevronRight size={18} />} hideFirstLastPages={true} activePage={currentPage} itemsCountPerPage={dataPerPage} totalItemsCount={type === mainContactTabs.ai ? totalCompanyCount : contactsCount} pageRangeDisplayed={8} onChange={(e) => handlePageChange(e)} />
            </div>
          )}
        </>
      </div>
      <SalesforceDuplicateModal
        closeButton={() => {
          setShowSalesForceDuplicateModal(false);
          setDuplicateSalesforceData({});
        }}
        showButton={showSalesForceDuplicateModal}
        duplicateCount={duplicateSalesforceData?.count || 0}
        duplicateData={duplicateSalesforceData?.data || []}
        type={"contacts"}
      />
    </IntelLayout>
  );
};
export default DashboardAddressBook;
